<template>
  <section class="media">
    <div class="wrap">
      <div class="media-thumbnail">
        <span @click.prevent="play" class="icon icon-play" v-if="!playing">
          <icon-play />
        </span>

        <img v-if="thumbnail && !playing" :src="thumbnail" alt="" >

        <video-player v-if="playing" :src="src" />

        <div ref="overlay" class="media-overlay"></div>
      </div>

      <slot></slot>
    </div>
  </section>
</template>

<script>
import iconPlay from '@icons/icon-play'
import VideoPlayer from '@/components/video-player'
import { TweenLite } from 'gsap'

export default {
  components: { iconPlay, VideoPlayer },
  props: {
    thumbnail: { type: String, required: false, default: null },
    src: { type: String, required: true }
  },
  data: () => ({
    playing: false
  }),
  methods: {
    play () {
      TweenLite.to(this.$refs.overlay, 0.255, {
        x: 0,
        onComplete: () => {
          this.playing = true
          TweenLite.to(this.$refs.overlay, 0.255, { x: '-100%' })
        }
      })
    }
  }
}
</script>

<style lang="scss">
/* Import from Spar Nord Assets */
@import '~@styles/global/index';
@import '~@styles/colors/variables';
@import '~@styles/mq/variables';
@import '~@styles/mixins/index';
@import '~@animations/easings/variables';
@import '~@animations/durations/variables';

.media .wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.media-thumbnail {
  flex: 1 1 50%;

  position: relative;
  background-color: $color-black-x;
  overflow: hidden;

  @include aspect-ratio(4, 3);

  @media #{$above-breakpoint-768} {
    @include aspect-ratio(16, 9);
  }

  img {
    @include object-fit(cover, center);
  }
}

.media-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $color-red-x;
  z-index: 2;
  transform: translateX(100%);
}

.icon-play {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;

  background-color: rgba($color-red, .8);

  height: 80px;
  width: 80px;
  border-radius: 50%;

  transform: translate(-50%, -50%);

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 2px 10px 0 rgba(black, .3);

  transition: all $duration-normal $easeing-OutExpo;
  cursor: pointer;

  svg {
    transform: translateX(4px) scale(0.7);
  }

  &:hover {
    box-shadow: 0 5px 20px 0 rgba(black, .3);
    background-color: $color-red-x;
    transition: all $duration-normal $easeing-OutExpo;
  }
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/elements/media.vue